import { entitlementsSelectors } from 'app-components/flux/entitlements';
import simplifiLogo from 'assets/logos/simplifi-logo.svg';
import simplifiLogoTextQBP from 'assets/logos/simplifi-qbp-text-dark.svg';
import simplifiLogoTextWhiteQBP from 'assets/logos/simplifi-qbp-text-white.svg';
import simplifiLogoText from 'assets/logos/simplifi-text-dark.svg';
import simplifiLogoTextWhite from 'assets/logos/simplifi-text-white.svg';
import simplifiLogoTextLite from 'assets/logos/simplifi-lite-text-dark.svg';
import simplifiLogoTextWhiteLite from 'assets/logos/simplifi-lite-text-white.svg';

import { useAppSelector } from 'hooks/redux';
import React from 'react';
import { tss } from 'tss-react/mui';
import useThemeMode from 'hooks/useThemeMode';

const useStyles = tss.withParams().create(({ size }) => {
  switch (size) {
    case 'small':
      return {
        logo: {
          height: 32,
          marginRight: 8,
        },
        logoText: {
          height: 32,
        },
        container: {
          display: 'flex',
          alignItems: 'center',
        },
      };
    case 'large':
      return {
        logo: {
          height: 56,
          marginRight: 8,
        },
        logoText: {
          height: 56,
        },
        container: {
          display: 'flex',
          alignItems: 'center',
        },
      };
    default:
      return {
        logo: {
          height: 36,
          marginRight: 16,
        },
        logoText: {
          height: 36,
        },
        container: {
          display: 'flex',
          alignItems: 'center',
        },
      };
  }
});

type Props = {
  showLogo?: boolean;
  size?: 'small' | 'medium' | 'large';
};

export default function SimplifiAndQBPLogo(props: Props) {
  const { showLogo, size } = props;
  const { classes } = useStyles({ size });
  const topTier = useAppSelector(entitlementsSelectors.getTopTierEntitlement);
  const themeMode = useThemeMode();
  const lightLogo =
    (topTier?.id === 'ACME_LITE' && simplifiLogoTextLite) ||
    (topTier?.id === 'ACME_BASIC' && simplifiLogoText) ||
    (topTier?.id === 'ACME_HAB' && simplifiLogoTextQBP) ||
    simplifiLogoText;
  const darkLogo =
    (topTier?.id === 'ACME_LITE' && simplifiLogoTextWhiteLite) ||
    (topTier?.id === 'ACME_BASIC' && simplifiLogoTextWhite) ||
    (topTier?.id === 'ACME_HAB' && simplifiLogoTextWhiteQBP) ||
    simplifiLogoTextWhite;
  const logoTextSvg = themeMode === 'light' ? lightLogo : darkLogo;
  return (
    <div className={classes.container} id='simplifi-logo'>
      {showLogo && <img src={simplifiLogo} className={classes.logo} alt='Quicken' />}
      <img src={logoTextSvg} className={classes.logoText} alt='Quicken' />
    </div>
  );
}
